import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import ComparisonSection from './components/ComparisonSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://usfans.work';

  const homeSchemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'USFans Spreadsheet Polska',
      url: siteUrl,
      inLanguage: 'pl',
      publisher: {
        '@type': 'Organization',
        name: 'Redakcja USFans Polska',
        url: siteUrl,
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteUrl}/?s={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Redakcja USFans Polska',
      url: siteUrl,
      description: 'Największy polski przewodnik po USFans Spreadsheet — rankingi, porównania i aktualne arkusze.',
      inLanguage: 'pl',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Strona główna',
          item: siteUrl,
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen">
      <SEOHead jsonLd={homeSchemas} />
      <Navbar />
      <main>
        <HeroSection />
        <BenefitsSection />
        <ComparisonSection />
        <CategoriesSection />
        <ArticlesSection />
        <TrustSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}